// extracted by mini-css-extract-plugin
export var L = "captionimg-module--L--7b24d";
export var M = "captionimg-module--M--8c473";
export var S = "captionimg-module--S--d2837";
export var caption = "captionimg-module--caption--f8642";
export var imagestyle = "captionimg-module--imagestyle--19c0f";